import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import { countriesList } from './countriesList';
import { dropdownStyles } from './styles';
import styles from './styles.module.scss';

const PaymentAutocomplite = ({ countryCode, setCountryCode }) => {
    const style = dropdownStyles();
    const { t } = useTranslation();
    const NoOptionsMessage = useCallback(() => <div className={styles.noOption}>Enter your country</div>, []);

    const data = countriesList.map((item) => ({
        value: item?.code,
        label: item?.label
    }));

    const onSelectChange = (selectedOption) => {
        setCountryCode(selectedOption.value);
    };

    return (
        <div className={styles.wrapper}>
            <Select
                value={countriesList.find((country) => country.code === countryCode)}
                options={data}
                isClearable={false}
                onChange={onSelectChange}
                styles={style}
                noOptionsMessage={NoOptionsMessage}
                placeholder={t('labels.selectCountry')}
            />
        </div>
    );
};

export default PaymentAutocomplite;
